// 租赁账单相关常量（由 RentCollectionDetail.jsx 抽出）

export const BILL_TYPE_MAP = {
  rent: "租金",
  waterElectricity: "水电",
  propertyFee: "物业",
  deposit: "押金",
  other: "其他",
};

export const RENT_CYCLE_MAP = {
  daily: "日付",
  monthly: "月付",
  quarterly: "季付",
  yearly: "年付",
};

export const BILL_STATUS_MAP = {
  unpaid: { label: "未付款", color: "error" },
  partiallyPaid: { label: "部分付款", color: "warning" },
  paid: { label: "已付款", color: "success" },
  closed: { label: "已关闭", color: "default" },
  cancelled: { label: "已取消", color: "default" },
};

export const CONTRACT_STATUS_MAP = {
  active: { label: "生效中", color: "success" },
  moveOutScheduled: { label: "待退房", color: "warning" },
  pendingSettlement: { label: "待结算", color: "warning" },
  settled: { label: "已结算", color: "default" },
  cancelled: { label: "已取消", color: "default" },
  terminated: { label: "已终止", color: "default" },
};

export const PAYMENT_METHOD_MAP = {
  wechat: "微信",
  alipay: "支付宝",
  bank: "银行卡",
  cash: "现金",
  transfer: "转账",
};

// 账单状态全集（账单列表一次拉全，前端按分级条过滤）
export const ALL_BILL_STATUS = "unpaid,partiallyPaid,paid,closed,cancelled";

// TODO: 水电单价目前硬编码，建议改为后端配置
export const WATER_PRICE = 3;
export const ELECTRICITY_PRICE = 1;
export const BILL_TYPE_COLOR = {
  rent: "#2563eb",
  deposit: "#7c3aed",
  waterElectricity: "#0891b2",
  propertyFee: "#ea580c",
  other: "#64748b",
};
